function cssEscape(value) {
  if (window.CSS && typeof window.CSS.escape === "function") {
    return window.CSS.escape(value);
  }

  return value.replace(/["\\]/g, "\\$&");
}

function findFacetInputs(param, value) {
  var selector = 'facets-form-component input[name="' + cssEscape(param) + '"]';

  if (value) {
    selector += '[value="' + cssEscape(value) + '"]';
  }

  return Array.prototype.slice.call(document.querySelectorAll(selector));
}

function getHeroControlFromEvent(event) {
  var target = event.target;

  if (!(target instanceof Element)) return null;

  return target.closest(
    ".collection-hero__chip, .collection-hero__make, .collection-hero__product-type, .collection-hero__application-shortcut",
  );
}

function dispatchFacetChange(input) {
  input.dispatchEvent(new Event("change", { bubbles: true }));
}

function getShortcutFilterPairs(link) {
  var href = link.getAttribute("href");
  if (!href) return [];

  var shortcutUrl;
  try {
    shortcutUrl = new URL(href, window.location.origin);
  } catch (error) {
    return [];
  }

  var pairs = [];

  shortcutUrl.searchParams.forEach(function (value, key) {
    if (key.indexOf("filter.") === 0) {
      pairs.push({ param: key, value: value });
    }
  });

  return pairs;
}

function shortcutUrlMatchesCurrentQuery(link) {
  var filterPairs = getShortcutFilterPairs(link);

  var currentParams = new URLSearchParams(window.location.search);
  var matches = true;

  if (link.dataset.filterShortcut === "true" && filterPairs.length) {
    filterPairs.forEach(function (pair) {
      if (currentParams.getAll(pair.param).indexOf(pair.value) === -1) {
        matches = false;
      }
    });

    return matches;
  }

  var href = link.getAttribute("href");
  if (!href) return false;

  var shortcutUrl;
  try {
    shortcutUrl = new URL(href, window.location.origin);
  } catch (error) {
    return false;
  }

  var shortcutParams = new URLSearchParams(shortcutUrl.search);
  if (!Array.from(shortcutParams.keys()).length) return false;

  shortcutParams.forEach(function (value, key) {
    if (currentParams.getAll(key).indexOf(value) === -1) {
      matches = false;
    }
  });

  return matches;
}

function syncApplicationShortcutState() {
  var activeLabel = "";

  document
    .querySelectorAll(".collection-hero__application-shortcut:not(.collection-hero__application-shortcut--back)")
    .forEach(function (link) {
      var isActive = shortcutUrlMatchesCurrentQuery(link);

      link.classList.toggle("collection-hero__application-shortcut--active", isActive);

      if (isActive) {
        activeLabel = link.textContent.trim();
        link.setAttribute("aria-current", "page");
        if (link.dataset.filterParam || link.dataset.filterShortcut === "true") {
          link.removeAttribute("aria-disabled");
        } else {
          link.setAttribute("aria-disabled", "true");
        }
      } else {
        link.removeAttribute("aria-current");
        link.removeAttribute("aria-disabled");
      }
    });

  document
    .querySelectorAll("[data-application-shortcut-context]")
    .forEach(function (context) {
      if (activeLabel) {
        context.textContent = "Showing: " + activeLabel;
        context.hidden = false;
      } else {
        context.textContent = "";
        context.hidden = true;
      }
    });
}

var heroSyncTimer;
var heroPending = false;
var heroPendingTimer;

function toggleHeroLoadingIndicator(isPending) {
  var indicator = document.querySelector(".collection-hero-loading-indicator");

  if (isPending) {
    if (!indicator) {
      indicator = document.createElement("div");
      indicator.className = "collection-hero-loading-indicator";
      indicator.setAttribute("role", "status");
      indicator.setAttribute("aria-label", "Loading filters");
      document.body.appendChild(indicator);
    }

    indicator.hidden = false;
  } else if (indicator) {
    indicator.hidden = true;
  }
}

function setHeroPending(isPending) {
  heroPending = isPending;
  window.clearTimeout(heroPendingTimer);
  toggleHeroLoadingIndicator(isPending);

  document
    .querySelectorAll(".collection-hero-wrapper")
    .forEach(function (hero) {
      hero.classList.toggle("collection-hero-wrapper--loading", isPending);

      if (isPending) {
        hero.setAttribute("aria-busy", "true");
      } else {
        hero.removeAttribute("aria-busy");
      }
    });

  if (isPending) {
    heroPendingTimer = window.setTimeout(function () {
      setHeroPending(false);
    }, 2500);
  }
}

function scheduleHeroSync() {
  window.clearTimeout(heroSyncTimer);
  heroSyncTimer = window.setTimeout(syncHeroFromCurrentPage, 80);
}

function updateHeroActiveState(param) {
  var activeValues = findFacetInputs(param)
    .filter(function (input) {
      return input.checked;
    })
    .map(function (input) {
      return input.value;
    });

  document
    .querySelectorAll('.collection-hero-wrapper [data-filter-param="' + cssEscape(param) + '"]')
    .forEach(function (control) {
      var value = control.dataset.filterValue;
      var isClear = control.dataset.filterAction === "clear";
      var isActive = isClear ? activeValues.length === 0 : activeValues.indexOf(value) !== -1;

      if (control.classList.contains("collection-hero__chip")) {
        control.classList.toggle("collection-hero__chip--active", isActive);
      }

      if (control.classList.contains("collection-hero__make")) {
        control.classList.toggle("collection-hero__make--active", isActive);
      }

      if (control.classList.contains("collection-hero__product-type")) {
        control.classList.toggle("collection-hero__product-type--active", isActive);
      }

      if (control.classList.contains("collection-hero__application-shortcut")) {
        control.classList.toggle("collection-hero__application-shortcut--active", isActive);
      }

      var circle = control.querySelector(".collection-hero__circle");
      if (circle) {
        circle.classList.toggle("collection-hero__circle--active", isActive);
      }
    });
}

function syncHeroFromCurrentPage() {
  var currentHero = document.querySelector(".collection-hero-wrapper");
  if (!currentHero) {
    setHeroPending(false);
    return;
  }

  window
    .fetch(window.location.href, { credentials: "same-origin" })
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, "text/html");
      var nextHero = doc.querySelector(".collection-hero-wrapper");

      if (!nextHero || !currentHero.parentNode) {
        setHeroPending(false);
        return;
      }

      currentHero.replaceWith(nextHero);
      initSliders();
      syncApplicationShortcutState();
      setHeroPending(false);
    })
    .catch(function () {
      setHeroPending(false);
    });
}

function handleHeroFilterClick(event) {
  var control = getHeroControlFromEvent(event);
  if (heroPending && control) {
    event.preventDefault();
    return;
  }

  if (!control || control.getAttribute("aria-disabled") === "true") return;

  var param = control.dataset.filterParam;
  if (!param) return;

  var isClear = control.dataset.filterAction === "clear";
  var value = control.dataset.filterValue;
  var inputs = findFacetInputs(param, isClear ? "" : value).filter(function (input) {
    return !input.disabled;
  });

  if (!inputs.length) return;

  event.preventDefault();

  var didChange = false;

  if (isClear) {
    var changedInput = null;

    inputs.forEach(function (input) {
      if (input.checked) {
        input.checked = false;
        didChange = true;
        changedInput = input;
      }
    });

    if (changedInput) {
      dispatchFacetChange(changedInput);
    }
  } else {
    var input = inputs[0];
    input.checked = !input.checked;
    didChange = true;
    dispatchFacetChange(input);
  }

  if (!didChange) return;

  setHeroPending(true);
  updateHeroActiveState(param);
  scheduleHeroSync();
}

function handleApplicationShortcutClick(event) {
  var target = event.target;
  if (!(target instanceof Element)) return;

  var shortcut = target.closest('.collection-hero__application-shortcut[data-filter-shortcut="true"]');
  if (!shortcut) return;

  if (heroPending) {
    event.preventDefault();
    return;
  }

  if (!shortcut.classList.contains("collection-hero__application-shortcut--active")) {
    setHeroPending(true);
    return;
  }

  var filterPairs = getShortcutFilterPairs(shortcut);
  if (!filterPairs.length) return;

  var changedInput = null;

  filterPairs.forEach(function (pair) {
    findFacetInputs(pair.param, pair.value).forEach(function (input) {
      if (!input.disabled && input.checked) {
        input.checked = false;
        changedInput = input;
      }
    });
  });

  if (!changedInput) return;

  event.preventDefault();
  dispatchFacetChange(changedInput);

  setHeroPending(true);
  filterPairs.forEach(function (pair) {
    updateHeroActiveState(pair.param);
  });
  syncApplicationShortcutState();
  scheduleHeroSync();
}

function initSlider(slider) {
  if (slider.dataset.collectionHeroSliderReady === "true") return;

  var track = slider.querySelector("[data-slider-track]");
  var leftBtn = slider.querySelector(".collection-hero__slider-arrow--left");
  var rightBtn = slider.querySelector(".collection-hero__slider-arrow--right");
  if (!track || !leftBtn || !rightBtn) return;

  function updateState() {
    var overflowing = track.scrollWidth > track.clientWidth + 1;
    slider.classList.toggle("is-overflowing", overflowing);
    slider.classList.toggle("at-start", track.scrollLeft <= 0);
    slider.classList.toggle(
      "at-end",
      track.scrollLeft + track.clientWidth >= track.scrollWidth - 1,
    );
  }

  leftBtn.addEventListener("click", function () {
    track.scrollBy({ left: -Math.round(track.clientWidth * 0.8), behavior: "smooth" });
  });

  rightBtn.addEventListener("click", function () {
    track.scrollBy({ left: Math.round(track.clientWidth * 0.8), behavior: "smooth" });
  });

  track.addEventListener("scroll", updateState);
  window.addEventListener("resize", updateState);
  slider.dataset.collectionHeroSliderReady = "true";
  updateState();
}

function initSliders() {
  document
    .querySelectorAll(".collection-hero__slider")
    .forEach(initSlider);
}

function init() {
  if (document.documentElement.dataset.collectionHeroReady !== "true") {
    document.addEventListener("click", handleHeroFilterClick);
    document.addEventListener("click", handleApplicationShortcutClick);
    document.addEventListener("filter:update", scheduleHeroSync);
    document.documentElement.dataset.collectionHeroReady = "true";
  }

  initSliders();
  syncApplicationShortcutState();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
